"use client";

import { AsteroidSumActivity } from "./activities/AsteroidSumActivity";
import { ConstellationActivity } from "./activities/ConstellationActivity";
import { CountStarsActivity } from "./activities/CountStarsActivity";
import { PlanetJumpActivity } from "./activities/PlanetJumpActivity";
import { PuzzleActivity } from "./activities/PuzzleActivity";
import { SpellingActivity } from "./activities/SpellingActivity";
import { ActivitiesScreen } from "./screens/ActivitiesScreen";
import { BuilderScreen } from "./screens/BuilderScreen";
import { FlyScreen } from "./screens/FlyScreen";
import { HomeScreen } from "./screens/HomeScreen";
import { ProfileScreen } from "./screens/ProfileScreen";
import { StarShopScreen } from "./screens/StarShopScreen";
import { useGame } from "./GameProvider";

export function GameApp() {
  const { screen } = useGame();

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
      {(() => {
        switch (screen) {
          case "builder":
            return <BuilderScreen />;
          case "fly":
            return <FlyScreen />;
          case "activities":
            return <ActivitiesScreen />;
          case "profile":
            return <ProfileScreen />;
          case "star-shop":
            return <StarShopScreen />;
          case "activity-count-stars":
            return <CountStarsActivity />;
          case "activity-planet-jump":
            return <PlanetJumpActivity />;
          case "activity-spelling":
            return <SpellingActivity />;
          case "activity-constellation":
            return <ConstellationActivity />;
          case "activity-space-puzzle":
            return <PuzzleActivity />;
          case "activity-asteroid-sum":
            return <AsteroidSumActivity />;
          default:
            return <HomeScreen />;
        }
      })()}
    </div>
  );
}
